import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import { ARCHIVE_POSTS_PER_PAGE } from '@wix/communities-blog-client-common/dist/src/constants/pagination';
import PostListItem from '../post-search-list-item';
import Pagination from '../pagination-regular';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import { changePage } from '../../actions/change-page';
import fetchArchive from '../../actions/fetch-archive';
import { incrementPostLikeCount } from '../../actions/increment-post-like-count';
import { push } from '../../services/router-utils';
import styles from './archive-posts-list.scss';

class ArchivePostsDesktopList extends Component {
  state = {
    page: 1,
    from: 0,
    to: ARCHIVE_POSTS_PER_PAGE,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: Number(props.params.pageIndex || 1),
    };
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange({ page }) {
    const { year, month } = this.props.params;

    this.props.fetchArchive(year, month, page);
    this.props.push({
      pathname: `/archive/${year}/${month}/page/${page}`,
    });
  }

  renderItem(post, onPostLikeClick) {
    return <PostListItem key={post._id} post={post} onLikeClick={onPostLikeClick} />;
  }

  render() {
    const { posts, entityCount, onPostLikeClick, borderWidth } = this.props;
    const { page } = this.state;
    const style = {
      borderWidth,
      marginTop: -borderWidth,
    };
    return (
      <div className={classNames(styles.container, 'search-results-list')}>
        <div className={classNames(styles.wrapper, 'blog-card-border-color')} style={style}>
          {posts.map(post => this.renderItem(post, onPostLikeClick))}
          <Pagination
            className={classNames(styles.pagination, 'blog-card-background-color')}
            page={page}
            entityCount={entityCount}
            pageSize={ARCHIVE_POSTS_PER_PAGE}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}

ArchivePostsDesktopList.propTypes = {
  posts: PropTypes.array.isRequired,
  entityCount: PropTypes.number.isRequired,
  borderWidth: PropTypes.number.isRequired,
  onPostLikeClick: PropTypes.func,
  changePage: PropTypes.func.isRequired,
  fetchArchive: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  push,
  changePage,
  fetchArchive,
  onPostLikeClick: incrementPostLikeCount,
};

export default connect(
  undefined,
  mapDispatchToProps,
)(withCardBorderWidth(ArchivePostsDesktopList));
